<template>
  <div v-if="!loading">
    <div class="info--text text-uppercase my-3 mt-2">
      {{ generateMessage('requests.details.titles.contractualData') }}
    </div>
    <div class="d-flex pl-3">
      <div>
        <custom-simple-table
          :item="property.contractual_commitment"
          i18-path="properties_360.fields.contractual_commitment"
          :table-keys="['contract_reference', 'contract_reference_name']"
        />
        <display-checkbox
          :label="generateMessage('properties_360.fields.active_enabled')"
          :input-value="property.active_enabled"
        />
        <maintenance-contract-infos />
      </div>
    </div>
  </div>
</template>
<script>
import DisplayCheckbox from '@/components/displays/DisplayCheckbox';
import { createNamespacedHelpers } from 'vuex';
import { generateMessage } from '@/utils/i18n';
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import MaintenanceContractInfos from '../../../../FRI/MaintenanceContractInfos';

const { mapGetters } = createNamespacedHelpers('properties_360');

export default {
  name: 'property-contract',
  components: {
    CustomSimpleTable,
    DisplayCheckbox,
    MaintenanceContractInfos,
  },
  computed: {
    ...mapGetters({ property: 'current', loading: 'isLoadingCurrent' }),
    request() {
      return {
        property: {},
        ...this.active,
      };
    },
  },
  methods: {
    generateMessage,
  },
};
</script>
